import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-raamkruk-vervangen"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Raamkruk vervangen"
    />
  );
}